import React, { useState } from 'react';
import Layout from '../../components/global/layout';
import Pagination from 'react-pagination-js';
// import './style.scss'
import methodModel from '../../methods/methods';
import datepipeModel from '../../models/datepipemodel';
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Tooltip } from 'antd';
import { HiOutlineArrowDown } from 'react-icons/hi';
import { FiEdit3, FiPlus } from 'react-icons/fi';
import { BsTrash3 } from 'react-icons/bs';
import { PiFileCsv } from 'react-icons/pi';
import SelectDropdown from '../../components/common/SelectDropdown';
import statusModel from '../../models/status.model';
import View from '../Events/View';
import { FaEye } from 'react-icons/fa';
import { HiArrowSmUp } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

const Html = ({
  sortClass,
  sorting,
  type,
  add,
  edit,
  ChangeRole,
  UpdateStatus,
  pageChange,
  deleteItem,
  exportfun,
  filters,

  loaging,
  data,
  statuschange,
  reset,
  cattype,
  dynamicStyle = false,
  className = null,
  total,
  dragStart,
  dragEnter,
  drop,
  dargEnterIndex,
  dargIndex,
  isAllow,
  showData,
  setFilter,
  getData,
}) => {
  const history = useNavigate();
  const view = (id) => {
    history('/transactions/view/' + id);
  };

  const renderSortIcon = (columnKey) => {
    if (filters.key !== columnKey)
      return <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
    else {
      if (filters.sorder === 'asc') {
        <HiArrowSmUp className="shrink-0 inline text-sm" />;
      } else {
        <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
      }
    }
    return filters.sorder === 'asc' ? (
      <HiArrowSmUp className="shrink-0 inline text-sm" />
    ) : (
      <HiOutlineArrowDown className="shrink-0 inline text-sm" />
    );
  };
  const [status, setstatus] = useState('');
  const handleItemCountChange = (e) => {
    setFilter({ ...filters, page: 1, count: e?.target?.value });
    getData({ page: 1, count: e?.target?.value });
  };
  const capitalizeFirstLetter = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const TableRow = ({ itm, className, index, parentCategory }) => {
    return (
      <tr
        className={` ${className || ''} ${dargIndex == index ? 'dragStart' : ''
          } ${dargEnterIndex == index ? 'dragEnter' : ''}`}
        onDragStart={(e) => dragStart(e, index)}
        onDragEnter={(e) => dragEnter(e, index)}
        onDragEnd={(e) => drop(e)}
        key={index}
        draggable={parentCategory ? false : true}
      >
        <td
          className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]"
        >
          {' '}
          <Tooltip placement="right" title="View">
          <div className="user_detail cursor-pointer" onClick={(e) => edit(itm.id)}>
            <img
              src={
                itm.image
                  ? methodModel.userImg(itm.image)
                  : methodModel.noImg(itm.banner)
              }
              className="cat_img"
            />
          </div>
          </Tooltip>
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0] capitalize">
          {itm.name || '--'}
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          {itm.parentCategory?.name || '--'}
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          {itm.catType?.name}
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          {datepipeModel.date(itm.updatedAt)}
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          {datepipeModel.date(itm.updatedAt)}
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          {itm?.updatedBy?.fullName || '--'}
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          {' '}
          <div
            className={`user_hours ${itm.status}`}
            onClick={() => statuschange(itm)}
          >
            <Tooltip
              placement="top"
              title={itm.status != 'deactive' ? 'Inactive' : 'Active'}
            >
              <span
                className={`text-sm !px-3 h-[30px] flex items-center justify-center border border-[#EBEBEB]  text-white !rounded capitalize ${itm.status === 'active' ? 'bg-[#1c2b35]' : 'bg-[#A12238] '
                  }`}
              >
                {itm.status == 'deactive' ? 'Inactive' : 'Active'}
              </span>
            </Tooltip>
          </div>
        </td>
        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
          <div className="flex items-center gap-1.5">
            {isAllow('blog_edit') ? (
              <Tooltip placement="top" title="Edit">
                <a
                  className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                  title="Edit"
                  onClick={(e) => edit(itm.id)}
                >
                  <FiEdit3 />
                </a>
              </Tooltip>
            ) : (
              <></>
            )}
            {isAllow('blog_delete') ? (
              <Tooltip placement="top" title="Delete">
                <span
                  className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md "
                  onClick={() => deleteItem(itm.id)}
                >
                  <BsTrash3 />
                </span>
              </Tooltip>
            ) : (
              <></>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <Layout>
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-2xl font-semibold text-[#111827]">
            {type ? 'Reseller' : ''} Transactions
          </h3>
          <p class="text-sm font-normal text-[#525252]">
            Here you can see all about your Transactions
          </p>
        </div>


      </div>

      <div className="shadow-lg w-full bg-white rounded-lg mt-6">


        <div className="scrollbar w-full overflow-auto">
          <table class="w-full">
            <thead className="text-xs text-gray-700 capitalize bg-gray-50  border-b border-[#EAECF0]">
              <tr className="border-b border-[#EAECF0]">
                <th
                  // onClick={(e) => sorting('fullName')}
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap "
                >
                  Transaction Id
                </th>
                <th
                  onClick={(e) => sorting('fullName')}
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap "
                >
                  Customer Name <span className="mr-2">{renderSortIcon('fullName')}</span>
                </th>

                <th
                  onClick={(e) => sorting('name')}
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                >
                  Plan Name{' '}
                  <span className="mr-2">{renderSortIcon('name')}</span>
                </th>

                <th
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                  onClick={(e) => sorting('amount')}
                >
                  Amount{' '}
                  <span className="mr-2">{renderSortIcon('amount')}</span>
                </th>

                <th
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                  onClick={(e) => sorting('updatedAt')}
                >
                  Date Created{' '}
                  <span className="mr-2">{renderSortIcon('updatedAt')}</span>
                </th>


                {/* <th
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                >
                  Status
                </th> */}

                {/* <th
                  scope="col"
                  className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                >
                  Action
                </th> */}

              </tr>
            </thead>
            <tbody id="tableBodycat">
              {!loaging &&
                data &&
                data?.map((itm, i) => {
                  return (
                    <tr className="">
                      <td
                        className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]"
                      // onClick={(e) => view(itm.id)}
                      >
                        <h4 className="user">
                          {(itm?.payment_intent_id)}
                        </h4>
                      </td>
                      <td
                        className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]"
                      // onClick={(e) => view(itm.id)}
                      >
                        <h4 className="user">
                          {capitalizeFirstLetter(itm?.fullName)}
                        </h4>
                      </td>
                      <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                        {capitalizeFirstLetter(itm?.name)}
                      </td>

                      {/* <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                          {datepipeModel.date(itm.lastLogin)}
                        </td> */}

                      <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                        ${" "}{(itm.amount)}
                      </td>

                      <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                        {datepipeModel.date(itm.updatedAt)}
                      </td>


                      <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                        <div className="flex items-center gap-1.5">
                          {isAllow('course_get') ? (
                            <>
                              {/* <Tooltip placement="top" title="View">
                                <a
                                  className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                  onClick={(e) => view(itm.id)}
                                >
                                  <FaEye />
                                </a>
                              </Tooltip> */}
                            </>
                          ) : (
                            <></>
                          )}
                          {isAllow('course_edit') ? (
                            <>

                            </>
                          ) : (
                            <></>
                          )}

                          {isAllow('course_delete') ? (
                            <>

                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {/* {!loaging &&
                data &&
                showData().map((itm, i) => {
                  return (
                    <>
                      <TableRow itm={itm} index={i} />
                      {itm?.childCategories &&
                        itm?.childCategories.map((citm) => {
                          return (
                            <>
                              <TableRow
                                itm={{ ...citm, id: citm._id }}
                                index={i}
                                className="subCategory"
                                parentCategory={itm}
                              />
                              {citm.childCategories &&
                                citm.childCategories.map((sitm) => {
                                  return (
                                    <TableRow
                                      itm={{ ...sitm, id: citm._id }}
                                      index={i}
                                      className="subSubCategory"
                                      parentCategory={citm}
                                    />
                                  );
                                })}
                            </>
                          );
                        })}
                    </>
                  );
                })} */}
            </tbody>
          </table>
        </div>

        {!loaging && data?.length === 0 ? (
          <div className="py-3 text-center text-[#8b8b8b]">No Data</div>
        ) : (
          <></>
        )}
        {!loaging && total > 10 ? (
          <div className="paginationWrapper  mt-15">
            <span className="text-sm text-gray-600">
              {filters?.count > total ? ` Show ${total} from ${total} User’s` : ` Show ${filters.count} from ${total} Transactions`}
            </span>
            <select
              className="border-[1px] border-[#cfd5dc] rounded-[5px] px-[5px] py-[5px] bg-white text-[12px] mr-3"
              value={filters.count} // Current value of items per page
              onChange={(e) => handleItemCountChange(e)} // Function to handle changes
            >
              {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>
            <Pagination
              currentPage={filters.page}
              totalSize={total}
              sizePerPage={filters.count}
              changeCurrentPage={pageChange}
            />

          </div>
        ) : (
          <></>
        )}
        {loaging ? (
          <div className="text-center py-4">
            <img src="/assets/img/loader.gif" className="pageLoader" />
          </div>
        ) : (
          <></>
        )}
      </div>
    </Layout>
  );
};

export default Html;
